import * as React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { requestGet } from '../../../../modules/request';
import { Snackbar, defaultSnackbarTimeout } from '../../../Shared/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';
import useSnackbarMonitor from '../../../Shared/hooks/useSnackbarMonitor'

const closeIconSrc = `${window.postbuildEnv.CDN_URL}/images/icons/close.svg`;
const shareToGoogleIconSrc = `${window.postbuildEnv.CDN_URL}/images/icons/icons-google-classroom-color.svg`;

interface ShareActivityModalPropsInterface {
  closeModal: () => void,
  link: string,
  title: string
}

export const ShareActivityModal = ({ closeModal, link, title }: ShareActivityModalPropsInterface) => {
  const { modalRef } = useModalAccessibility(close);
  const [showSnackbar, setShowSnackbar] = React.useState<boolean>(false);

  useSnackbarMonitor(showSnackbar, setShowSnackbar, defaultSnackbarTimeout)

  function handleCloseModal() {
    closeModal();
  }

  function handleCopyLink() {
    setShowSnackbar(true);
  }

  function handleShareToGoogleClassroomClick() {
    window.open(
      `https://classroom.google.com/share?url=${link}&title=${title}&body=Work on ${title}`,
      '_blank'
    );
  }

  function renderSnackbar() {
    return <Snackbar text="Link copied" visible={showSnackbar} />
  }

  function renderContent() {
    return (
      <React.Fragment>
        <div className="title-row">
          <h3 className="title" id="shareActivityModalTitle">Share this Activity with your students</h3>
          <button className='close-button focus-on-light interactive-wrapper' onClick={handleCloseModal} type="button">
            <img alt="close-icon" src={closeIconSrc} />
          </button>
        </div>
        <p className="disclaimer-text">This is a link for a student to complete the activity. The student does not need an account or to sign in to complete the activity, but the data is not saved or stored. If you would like to assign the activity and view the results, sign in to your Quill account and assign it to your students from the Quill “Assign Activities” dashboard.</p>
        <div className="form-buttons">
          <CopyToClipboard onCopy={handleCopyLink} text={link}>
            <button className="quill-button grey outlined medium focus-on-light" type="button">Copy link</button>
          </CopyToClipboard>
          <button className="quill-button grey outlined medium focus-on-light" onClick={handleShareToGoogleClassroomClick} type="button">
            <img alt="close-icon" src={shareToGoogleIconSrc} />
            Share to Google Classroom
          </button>
        </div>
      </React.Fragment>
    );
  }

  return (
    <div className="modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="shareActivityModalTitle"
        aria-modal="true"
        className="share-activity-pack-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        {renderContent()}
      </div>
      {renderSnackbar()}
    </div>
  );
}

export default ShareActivityModal;
